<template>
    <div @click="toggleFullScreen">
      <pdf :src="src" style="cursor: zoom-in;" />
      <a-modal
        :visible="isFullScreen"
        width="50%"
        :footer="null"
        @cancel="toggleFullScreen"
      >
        <pdf :src="src" style="height: 100%;" />
      </a-modal>
    </div>
  </template>
  
  <script>
  import { defineComponent } from 'vue';
  import pdf from 'vue-pdf';
  
  export default defineComponent({
    name: 'CustomPdf',
    components: {
      pdf
    },
    props: {
      src: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        isFullScreen: false
      };
    },
    methods: {
      toggleFullScreen() {
        this.isFullScreen = !this.isFullScreen;
      }
    }
  });
  </script>
